// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1GtxK","list":"PatternAutocomplete_list__2j9tn"};